import React, { useState } from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Card, CardBody, Container } from 'reactstrap';

//redux
import FlowRatesForm from '../Forms/FlowRatesForm';
import { useNavigate, useParams } from 'react-router-dom';
import Register from '../../Authentication/Register';
import {Icons} from '../../../utils/Icons';

const WatherRightRegister = () => {
    const { id } = useParams();
    const [title, setTitle] = useState('');
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: Icons.house },
		{ to: '#', label: 'Medio Ambiente', icon: Icons.environment  },
        { to: '/water-rights/list', label: 'Derechos de Agua', icon: Icons.water },	
    ];

    //Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
                    <BreadCrumb 
                        title={Register ? 'Registrar Usuario' : title || 'Registrar Derecho de Agua'}   
                        links={breadcrumbLinks}
                    />
                    {/* <div className='modal-content border-0 mt-3'>
                        <Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
                            <NavItem>
                                <NavLink
                                    href='#'
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => {
                                        toggleTab('1');
                                    }}
                                >
                                    Información General
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href='#'
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => {
                                        toggleTab('2');
                                    }}
                                >
                                    Conversiones
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div> */} 
                            <FlowRatesForm
                                key={id || 'new'}
                                activeTab={activeTab}
                                handleChangeTitleForm={(newTitle) => {
                                    setTitle(newTitle);
                                }}
                                handleToggleModal={() => {}}
                                // handleToggleModal={() => history('/residue/guides')}
                                requireGuideDetailRegisterList={true}
                            /> 
					
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WatherRightRegister;
